'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, QuoteFeedEvent, Security, QuoteDetail, QuoteFeed } from '@benzinga/quotes-manager';
import Hooks from '@benzinga/hooks';

export const useQuoteSubscriptionDetail = (symbol: Security): QuoteDetail | undefined => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesManager);
  const [details, setDetails] = React.useState(() => quotesManager.getCachedQuoteDetail(symbol));
  const [feed, setFeed] = React.useState<QuoteFeed | undefined>(() =>
    details ? undefined : quotesManager.createQuoteFeed(symbol),
  );

  React.useEffect(() => {
    const details = quotesManager.getCachedQuoteDetail(symbol);
    setDetails(details);
    setFeed(details ? undefined : quotesManager.createQuoteFeed(symbol));
  }, [quotesManager, symbol]);

  React.useEffect(() => {
    if (details !== undefined) {
      setFeed(undefined);
    }
  }, [details]);

  Hooks.useSubscriber(feed, (event: QuoteFeedEvent) => {
    switch (event.type) {
      case 'quote:quote_details':
        setDetails(event.detail);
        setFeed(undefined);
        break;
    }
  });

  return details;
};
